import type { CapabilityName } from './models/component';
import { COMPONENT_DEVICE_IFRAME_POLICY } from './component-device-api';

export function componentFramePolicy(grants: readonly CapabilityName[] = []): string {
  // 沙箱文档是不透明来源，需使用 * 授权；是否开放只由宿主的有效权限决定。
  const fullscreen = grants.includes('ui.fullscreen') ? '*' : "'none'";
  return `${COMPONENT_DEVICE_IFRAME_POLICY}; fullscreen ${fullscreen}`;
}
